import React from 'react'
import Markdown from 'react-markdown'

interface Props {
  incoming: boolean
  message: string
}

export const Message: React.FC<Props> = (props) => {
  if (props.incoming) {
    return (
      <li className="flex justify-start gap-x-2 sm:gap-x-4">
        <div className="grow text-left space-y-3">
          <div className="inline-block bg-gray-100 rounded-2xl py-2 px-3 shadow-sm">
            <p className="text-md text-gray-800 max-w-2xl">
              <Markdown>{props.message}</Markdown>
            </p>
          </div>
        </div>
      </li>
    )
  }

  return (
    <li className="flex justify-end gap-x-2 sm:gap-x-4">
      <div className="bg-blue-600 border border-gray-200 rounded-2xl py-2 px-3 space-y-3">
        <p className="text-md text-white max-w-2xl">
          <Markdown>{props.message}</Markdown>
        </p>
      </div>
    </li>
  )
}
